/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_norm_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concentrated H2SO4 (density 1.84, assay 98%, EW 49.04): N = 10 × 1.84 × 98 / 49.04 ≈ 36.8 N.`)
};

const es_norm_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`H2SO4 concentrado (densidad 1.84, ensayo 98%, PE 49.04): N = 10 × 1.84 × 98 / 49.04 ≈ 36.8 N.`)
};

const de_norm_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konzentrierte H2SO4 (Dichte 1,84, Gehalt 98%, EW 49,04): N = 10 × 1,84 × 98 / 49,04 ≈ 36,8 N.`)
};

const nl_norm_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geconcentreerd H2SO4 (dichtheid 1,84, gehalte 98%, EW 49,04): N = 10 × 1,84 × 98 / 49,04 ≈ 36,8 N.`)
};

const fr_norm_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`H2SO4 concentré (densité 1,84, titre 98 %, EG 49,04) : N = 10 × 1,84 × 98 / 49,04 ≈ 36,8 N.`)
};

const it_norm_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`H2SO4 concentrato (densità 1,84, titolo 98%, PE 49,04): N = 10 × 1,84 × 98 / 49,04 ≈ 36,8 N.`)
};

const pt_br2_norm_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`H2SO4 concentrado (densidade 1,84, teor 98%, PE 49,04): N = 10 × 1,84 × 98 / 49,04 ≈ 36,8 N.`)
};

const pt_norm_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`H2SO4 concentrado (densidade 1,84, título 98%, EG 49,04): N = 10 × 1,84 × 98 / 49,04 ≈ 36,8 N.`)
};

const ja_norm_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`濃硫酸 (密度1.84、アッセイ98%、当量49.04): N = 10 × 1.84 × 98 / 49.04 ≈ 36.8 N。`)
};

const zh_norm_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浓硫酸（密度 1.84，含量 98%，当量重量 49.04）：N = 10 × 1.84 × 98 / 49.04 ≈ 36.8 N。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const norm_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.norm_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("norm_ex2", locale)
	if (locale === "en") return en_norm_ex2(inputs)
	if (locale === "es") return es_norm_ex2(inputs)
	if (locale === "de") return de_norm_ex2(inputs)
	if (locale === "nl") return nl_norm_ex2(inputs)
	if (locale === "fr") return fr_norm_ex2(inputs)
	if (locale === "it") return it_norm_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_norm_ex2(inputs)
	if (locale === "pt") return pt_norm_ex2(inputs)
	if (locale === "ja") return ja_norm_ex2(inputs)
	return zh_norm_ex2(inputs)
};